import React, {lazy, Suspense, useEffect, useRef, useState} from "react";
import {API} from "../../utils/Constants";
import RequestSvc from "../../services/RequestSvc";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
import LoaderComponent from "../loaders/LoaderComponent";
import {queryObjectToString} from "../../utils/Utils";
import Skeleton from "react-loading-skeleton";
import FollowOfferWindow from "../modalWindows/offer/FollowOfferWindow";
import ChartFollowOfferWindow from "../modalWindows/chart/ChartFollowOfferWindow";

const CardAdLazyComponent = lazy(() => import("../cardViews/CardViewUserAdVault"));
// Componente Card memorizado
const MemoizedCardAd = React.memo(({
                                       item,
                                       index,
                                       gridShowAdDetail,
                                       numberDuplicates,
                                       onDeleteItem,
                                       showHideOfferFollowWindow
                                   }) => (<Suspense fallback={<LoaderComponent/>}>
    <CardAdLazyComponent
        key={item.LibraryID}
        index={index}
        item={item}
        gridShowAdDetail={gridShowAdDetail}
        numberDuplicates={numberDuplicates}
        onDeleteItem={onDeleteItem}
        showHideOfferFollowWindow={showHideOfferFollowWindow}
    />
</Suspense>));
export default React.memo(function ({
                                        queryStringObject,
                                        setShowDetails,
                                        showDetails,
                                        setItemSelectedDetail,
                                        setSidebarOpen,
                                        setShowContainerNoMoreData,
                                        setIsLoadingData,
                                        newRow = {},
                                        refreshVaultTrigger = 0
                                    }) {
    /*  INIT VARS   */

    /**
     * Contiene los datos de la grilla.
     */
    let [rowsAdsData, setRowsAdsData] = useState([]);
    /**
     * Indica si hay mas paginas o anuncios por cargar.
     */
    const [hasMore, setHasMore] = useState(true);
    /**
     *
     * @type {React.MutableRefObject<null>}
     */
    const elementRef = useRef(null);
    /**
     * Contiene la informacion del card seleccionado.
     */
    const [itemSelected, setItemSelected] = useState({});
    /**
     * Objeto de la clase que se usa para hacer request
     * @type {RequestSvc}
     */
    const requestSvc = new RequestSvc();
    /**
     * NUmero de pagina que se esta solicitando al servidor
     * @type {number}
     */
    let [requestId, setRequestId] = useState(1);
    /**
     * Flag que indica si se esta cargando informacion.
     */
    const [isLoading, setIsLoading] = useState(false);
    /**
     * Ultimo query usado.
     */
    let [lastQuery, setLastQuery] = useState({});
    /**
     * Flag que indica si se debe mostrar la ventada modal para hacer seguimiento de la oferta.
     */
    const [showFollowOfferWindow, setShowFollowOfferWindow] = useState(false);
    const [showChartDataWindow, setShowChartDataWindow] = useState(false);
    const [item, setItem] = useState(null)
    const [newRowAdded, setNewRowAdded] = useState({})

    /*  END VARS    */


    /*  INIT EVENTS */

    /**
     * Evento que se dispara cuando se da click en el boton de cerrar el detalle del anuncio.
     */
    const handleCloseDetails = () => {
        setShowDetails(false);
    };

    /**
     * Evento que se dispara cuando se va a mostrar los detalles del anuncio
     * @param item
     * @returns {Promise<void>}
     */
    const handleShowDetails = async (item) => {
        setSidebarOpen(false)
        setShowDetails(true);
        setItemSelected(item);
        setItemSelectedDetail(item)
    };

    /**
     * Evento que se dispara cuando se da click en el cardView
     * @param item
     */
    const handleCardClick = (item) => {
        if (showDetails && itemSelected.LibraryID === item.LibraryID) {
            handleCloseDetails(); // Si la misma tarjeta se clickea, cerrar
        } else {
            handleShowDetails(item);
        }
    };
    /**
     * Evento que se dispara cuando el usuario desea eliminar el anuncio de su biblioteca o baul
     * @param anuncioUUID
     */
    const onDeleteItem = async (anuncioUUID) => {
        let adBeenRemoved = await deleteSavedAd(anuncioUUID)
        if (adBeenRemoved) {
            let newDataGrid = [];
            rowsAdsData.forEach((cardInfo) => {
                if (cardInfo.AnuncioUUID !== anuncioUUID) {
                    newDataGrid.push(cardInfo);
                }
            })
            setRowsAdsData(newDataGrid)
        } else {
            alert("No hemos logrado eliminar tu anuncio, por favor inténtalo más tarde.")
        }
    }

    const showHideOfferFollowWindow = (state, item) => {
        if (!state && item === null) {
            setShowFollowOfferWindow(false);
        }
        if (state && item && item.OffersFollo_ID === null) {
            setItem(item)
            setShowFollowOfferWindow(true);
        }
        if (state && item && item.OffersFollo_ID !== null) {
            setItem(item)
            setShowChartDataWindow(true)
        }
    }

    const showHideOChartDataWindow = (state, item) => {
        setShowChartDataWindow(false)
    }


    /*  END EVENTS  */


    /*  INIT METHODS - FUNCTIONS*/

    /**
     * Callback para el IntersectionObserver que maneja la carga infinita
     * Se ejecuta cuando el elemento observado entra en el viewport
     * @param {IntersectionObserverEntry[]} entries - Array de elementos observados
     * @returns {Promise<void>}
     */
    const onIntersection = async (entries) => {
        const firstEntry = entries[0];
        if (firstEntry.isIntersecting && hasMore) {
            if (queryStringObject) {
                if (!queryStringObject.page) {
                    queryStringObject.page = 0;
                }
            } else {
                queryStringObject = {};
                queryStringObject.page = 0;
            }
            if (!isLoading) {
                await loadUserAd(queryStringObject)
            }
        }
    }
    /**
     *
     * @param getQueryString
     * @returns {Promise<*[]|boolean>}
     */
    const loadUserAd = async (getQueryString = null) => {
        try {
            if (!isLoading) {
                getQueryString.page = (getQueryString.page + 1);
                setLastQuery(queryStringObject)
                let url = 'https://pulpoia-ops.com/backend/nodeapi/dashboard';
                // FK_Category_Code=3x602gjKQ&filterName=3-x
                let queryString = queryObjectToString(getQueryString);
                url += `?${queryString}`;
                // url += `?${queryString}&FK_Category_Code=3x602gjKQ&filterName=3-x`;
                setIsLoading(true)
                setIsLoadingData(true)
                const res = await requestSvc.get(url);
                if (res.code !== 200) {
                    throw new Error(res.message);
                }
                if (res.data.length === 0) {
                    setHasMore(false)
                    setShowContainerNoMoreData(true)
                    setIsLoadingData(false)
                    // await addRowsInfo(res.data)
                } else {
                    setHasMore(true)
                    setShowContainerNoMoreData(false)
                    await addRowsInfo(res.data)
                    // Cambiar el id del request, de esta manera se ejecutara una nueva carga de datos.
                    setRequestId(Date.now)
                }
                await addRowsInfo(res.data)
            }
        } catch (error) {
            setIsLoadingData(false)
            setHasMore(false)
            setShowContainerNoMoreData(true)
            alert("Hubo un error, por favor recarga la página.")
        }
        return rowsAdsData
    }

    /**
     * Agregar filas a la grilla.
     * @param rowsInfo
     * @returns {Promise<*[]>}
     */
    const addRowsInfo = async (rowsInfo) => {
        if (rowsAdsData.length === 0) {
            setRowsAdsData(rowsInfo)
        } else {
            for (let row of rowsInfo) {
                rowsAdsData.push(row)
            }
        }
        setIsLoadingData(false)
        setIsLoading(false)
        return rowsAdsData
    }
    /**
     * Eliminar el anuncio guardado por el usuario.
     * @param anuncioUUID
     * @returns {Promise<boolean>}
     */
    const deleteSavedAd = async (anuncioUUID) => {
        const resultApi = await requestSvc.delete('https://nodeapi.tueducaciondigital.site/dashboard', {Id_ads: anuncioUUID});
        return !(resultApi.code !== 200 || resultApi.error === true);
    }

    /**
     *
     * @returns {Promise<void>}
     */
    const getDataWhitFilters = async () => {
        await resetRows();
        await loadUserAd(queryStringObject)
    }
    /**
     * Resetear o borrar los items de la grilla.
     * @returns {Promise<boolean>}
     */
    const resetRows = async () => {
        rowsAdsData = []
        rowsAdsData.slice();
        return true
    }

    /*  END METHODS - FUNCTIONS */


    /*  INIT TRIGGERS   */

    useEffect(() => {
        const isObject = newRow !== null && typeof newRow === 'object'
        if (!isObject) return
        if (Object.keys(newRow).length === 0) return
        if (JSON.stringify(newRow) === JSON.stringify(newRowAdded)) return

        setNewRowAdded(newRow)
        setRowsAdsData((prev) => [newRow, ...(Array.isArray(prev) ? prev : [])])
    }, [newRow, newRowAdded])

    useEffect(() => {
        const nextQuery = queryStringObject ?? {}
        if (JSON.stringify(nextQuery) !== JSON.stringify(lastQuery)) {
            getDataWhitFilters().then()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryStringObject])

 

    useEffect(() => {
        // Crear un nuevo IntersectionObserver con un margen amplio para precarga
        // y un umbral del 50% de visibilidad del elemento
        const observer = new IntersectionObserver(onIntersection, {rootMargin: '1250px', threshold: 0.5})
        if (observer && elementRef.current) observer.observe(elementRef.current)
        return () => {
            if (observer) observer.disconnect()
        }
    }, [rowsAdsData, requestId])


    /*  END  TRIGGERS   */

    return (
        <div className={"grid-main-layout"} style={{marginTop: "0", marginRight: "8px"}}>
            <ResponsiveMasonry columnsCountBreakPoints={
                {236: 1, 472: 2, 708: 3, 944: 4, 1180: 5, 1416: 6, 1652: 7, 1888: 8}
            }
                               style={{marginLeft: "8px", marginRight: "8px"}}>
                <Masonry gutter={"16px"}>
                    {
                        rowsAdsData.length > 0 && (
                            rowsAdsData.map((item, index) => {
                                item.duplicates = item.Duplicated ?? 0;
                                item.Active = item.Estatus ?? false;
                                return (
                                    <div key={index} style={{display: "grid"}}>
                                        <MemoizedCardAd
                                            item={item}
                                            index={index}
                                            gridShowAdDetail={handleCardClick}
                                            numberDuplicates={0}
                                            onDeleteItem={onDeleteItem}
                                            showHideOfferFollowWindow={showHideOfferFollowWindow}
                                        />
                                    </div>
                                )
                            })
                        )
                    }
                </Masonry>
            </ResponsiveMasonry>
            {
                hasMore && (
                    <div className="grid-reference-limit-loading" ref={elementRef}>
                        <div style={{
                            marginTop: '20px', display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: '10px'
                        }}>
                            {[...Array(7)].map((_, index) => (<Skeleton
                                key={index}
                                style={{
                                    height: '300px', borderRadius: '8px',
                                }}
                            />))}
                        </div>
                    </div>
                )
            }
            {
                showFollowOfferWindow && (
                    <FollowOfferWindow
                        showFollowOfferWindow={showFollowOfferWindow}
                        showHideOfferFollowWindow={showHideOfferFollowWindow}
                        item={item}/>
                )
            }
            {
                showChartDataWindow && (
                    <ChartFollowOfferWindow
                        showChartDataWindow={showChartDataWindow}
                        setShowChartDataWindow={setShowChartDataWindow}
                        item={item}/>
                )
            }
        </div>
    );
})